export type CarOverviewNavBarItem =
  | 'Summary'
  | 'Interior'
  | 'Exterior'
  | 'Features'
  | 'Performance'
  | 'Comfort'
  | 'WrapUp';

export const navItems: { key: CarOverviewNavBarItem; title: string }[] = [
  { key: 'Summary', title: 'Summary' },
  { key: 'Interior', title: 'Interior' },
  { key: 'Exterior', title: 'Exterior' },
  { key: 'Features', title: 'Features' },
  { key: 'Performance', title: 'Performance' },
  { key: 'Comfort', title: 'Comfort' },
  { key: 'WrapUp', title: 'Wrap Up' },
];
